import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'amenityLabel',
})
export class AmenityLabelPipe implements PipeTransform {
  transform(amenityKey: string, flattenedAmenities: { key: string; label: string; description: string }[]): string {
    const result = flattenedAmenities.find((x) => x.key === amenityKey);

    if (result) {
      return result.label;
    } else {
      return amenityKey;
    }
  }
}
